// features/tree/pageTurnBus.ts — one-shot trigger for the book-index
// "turn to that page" transition
//
// Same shape and reasoning as features/home/bookFlipBus.ts: the overlay
// (PageTurnOverlay) has to survive the route change it ends in — it stays
// visible while BookIndexScreen unmounts and the target screen (canvas,
// Matrimony, …) mounts underneath it — so it's rendered once in PageShell,
// outside BookIndexScreen's own tree. A plain pub-sub singleton rather than
// routing this through Zustand, since it's a transient, non-reactive,
// single-consumer imperative trigger with nothing else needs to observe.

export interface PageTurnParams {
  /** Route to land on once the page-flip sequence finishes. */
  to: string;
  /**
   * The current screen's page-content root, cloned onto the turning
   * page's front face so it visually reads as the real page lifting off
   * (matching BookFlipOverlay's cloneCover() approach) rather than a
   * blank panel replacing it outright.
   */
  sourceEl: HTMLElement;
}

type Handler = (params: PageTurnParams) => void;

let handler: Handler | null = null;

export function registerPageTurnHandler(fn: Handler | null): void {
  handler = fn;
}

/** Returns true if an overlay was mounted and the transition started. */
export function triggerPageTurn(params: PageTurnParams): boolean {
  if (!handler) return false;
  handler(params);
  return true;
}
